import React, { FunctionComponent, SVGProps } from "react";

export const RunFlatIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="currentColor"
      height="24"
      viewBox="0 0 1024 496"
      width="50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M557 427.423c-60.15.162-119.802.807-179.446.365-78.478-.582-156.953-.152-235.43-.323-3.79-.008-6.02-1.234-8.112-4.377-21.487-32.3-33.756-67.66-36.443-106.43-7.332-105.76 64.28-202.544 169.843-224.597 103.003-21.518 201.996 32.072 242.564 125.31 13.52 31.073 18.932 63.706 17.159 97.452-1.008 19.168-3.804 38.29-11.138 56.05-4.735 11.468 3.61 23.477 16.54 23.64 5.49.069 10.986-.36 16.48-.364 38.492-.037 76.991-.488 115.473.113 36.16.566 72.305-.55 108.447-.018 12.276.18 21.352-6.587 20.17-20.483-.507-5.955-.164-11.992-.046-17.988.105-5.353 1.125-10.449 6.56-13.07 5.408-2.608 10.25-.978 14.955 2.264 26.065 17.96 52.19 35.832 78.296 53.732 6.884 4.72 9.273 10.46 7.464 17.962-1.821 7.555-5.803 10.649-13.94 10.728-94.47.914-188.94-.473-283.41.028-15.162.08-30.324.008-45.986.006m-147.394-100.27c7.002-24.98 5.461-49.225-5.452-72.961-19.228-41.818-67.91-66.278-112.772-56.32-68.655 15.238-102.12 89.647-67.368 150.744 21.412 37.645 63.125 56.499 103.276 49.617 40.91-7.012 68.27-31.062 82.316-71.08z" />
    </svg>
  );
};
